import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  ViewChild,
  inject,
} from '@angular/core';
import {
  catchError,
  combineLatest,
  concat,
  concatMap,
  from,
  interval,
  map, Observable,
  of,
  scan, shareReplay,
  startWith,
  switchMap,
  tap
} from 'rxjs';
import {messageContent, MessageModel} from './dataExample';
import { ChatService } from '@lcms/shared/mt-bot';
import * as moment from 'moment';
import { FormBuilder } from '@angular/forms';
import throttle from 'lodash-es/throttle';
import {UserService} from "@lcms/shared/data-access-user";
import {TrackingService} from "@lcms/shared/data-access-tracking";


declare let makeMDP: any;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-chat-inner',
  templateUrl: './chat-inner.component.html',
  styleUrls: ['./chat-inner.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatInnerComponent {
  @Input() isDrawer = false;
  // @HostBinding('class') class = 'card-body';
  modal =false
  @HostBinding('id') id = this.isDrawer
    ? 'kt_drawer_chat_messenger_body'
    : 'kt_chat_messenger_body';
  @ViewChild('messageInput', { static: true })
  messageInput: ElementRef<HTMLTextAreaElement>;

  @ViewChild('conversationContainer', { static: false })
  conversationContainer: ElementRef;

  @ViewChild('botResponseOutput', { static: false })
  botResponseOutput: ElementRef;

  chatService = inject(ChatService);
  userService = inject(UserService)
  trackingservice: TrackingService = inject(TrackingService);
  sendMessageEvent = new EventEmitter<{ data: MessageModel }>();
  userData$:Observable<any> = this.userService.getAuthUserData$.pipe(
    shareReplay(1)
  )
  canAccess$:Observable<boolean> = this.userService.getUserRole$.pipe(map(role => ['administrator','manager'].includes(role)))

  avatarImage$: Observable<any> = this.userService.avatarImage$.pipe(
    // filter(() => !!this.userService.user_id.getValue()),
    map((data: any) => data?.url),
    switchMap((url: any) => {
      return (url && (this.userService.user_id.getValue() === null || this.userService.user_id.getValue() === '' || this.userService.user_id.getValue() === undefined))  ? of(url) :  this.userData$.pipe(
        map((res) => res?.avatar)
      );
    }),
    shareReplay(1)
  );

  mdpjs = new makeMDP();

  fb = inject(FormBuilder);
  monFormulaire = this.fb.group({
    message: '',
  });
  throttledScroll = throttle(() => {
    console.log('scroll');
    this.conversationContainer.nativeElement.lastElementChild?.scrollIntoView?.(
      { behavior: 'smooth' }
    );
  }, 300);

  conversations$ :Observable<any> = this.chatService.conv_id$.pipe(
    switchMap((id)=>{
      if(id!==null){
       return from(this.chatService.getMessages(id)).pipe(
          tap(()=>(this.monFormulaire.controls.message.setValue(''))),
            map((response: any): MessageModel[] =>
              response?.messages.map(
                (msg: any) =>{
                 const msgs= ({
                    avatar:
                      'user' == msg.role ? 'avatars/300-1.jpg' : 'avatars/logo-sm.svg', //TODO: get user avatar
                    text: msg?.message ?this.parseTexte(msg?.message):[{type:'text' , content : '...'}],
                    createdAt: msg.createdAt,
                    time: msg.createdAt ?  moment(msg.createdAt).lang('fr').fromNow() : '',
                    type: 'user' == msg.role ? 'out' : 'in',
                  } as MessageModel)
                  msgs.text.map((track :any)=>{
                    // console.log('drrr',track)
                    if(Array.isArray(track?.content)){
                      const resourceIds = track.content.filter((ressource) =>
                        ressource?.hydrate?.includes('progression') || ressource?.hydrate?.includes('score') || ressource?.progression
                      ).map((ressource) => ressource?.id);
                      this.trackingservice.getTracking({ items: resourceIds.map(id => ({ type: 'resource', id })) }).pipe(
                        map(dataArray => {
                          // dataArray est supposé être un tableau de réponses
                          dataArray.forEach((dataItem) => {
                            track.content = track.content.map((ressource) => {
                              if (ressource.id === dataItem.item_id) {
                                delete ressource['hydrate']
                                // Mettre à jour la ressource avec les données reçues
                                return { ...ressource, ...dataItem };
                              }
                              return ressource;
                            });
                          });
                        })
                      ).subscribe();

                    }

                  })
                  return msgs
                }
              ),

            ),
          catchError((error: any) => {
          return of([] as MessageModel[]);
        }),
          )
      }else{
        return of([
          {
            avatar: 'avatars/logo-sm.svg', //TODO: get user avatar
            text: [{type :'text' ,content: this.parseMd(hello_message)}],
            createdAt: new Date(),
            time: 'maintenant',
            type: 'in',
          }
        ] as MessageModel[])
      }
    }
      ),
    switchMap((messages) =>
      from(this.sendMessageEvent).pipe(
        tap((evt) => {
          console.log('event', evt);
          //this.monFormulaire.value.message = '';
          this.monFormulaire.controls.message.setValue('');
        }),
        concatMap((evt) =>
          concat(
            of(evt.data),
            of({
              avatar: 'avatars/logo-sm.svg', //TODO: get user avatar
              text: [{type:'text' , content : '...'}],
              createdAt: new Date(), //TODO: get createdAt from server in the response
              time: moment(new Date()).lang('fr').fromNow(),
              type: 'in',
              typping: true,
              buffer: '...',
            } as MessageModel),
            this.chatService.sendMessage(this.StringifyParse(evt.data.text)).pipe(
              map(
                (msg: any) =>{
               const message = ({
                    avatar: 'avatars/logo-sm.svg', //TODO: get user avatar
                    text: this.parseTexte( msg?.message),
                    createdAt: new Date(), //TODO: get createdAt from server in the response
                    time: moment(new Date()).lang('fr').fromNow(),
                    type: 'in',
                    buffer: msg?.message,
                  } as MessageModel)
                  message.text.map((track :any)=>{
                      // console.log('drrr',track)
                    if(Array.isArray(track?.content)){
                      const resourceIds = track.content.filter((ressource) =>
                        ressource?.hydrate?.includes('progression') || ressource?.hydrate?.includes('score') || ressource?.progression
                      ).map((ressource) => ressource?.id);
                      this.trackingservice.getTracking({ items: resourceIds.map(id => ({ type: 'resource', id })) }).pipe(
                        map(dataArray => {
                          // dataArray est supposé être un tableau de réponses
                          dataArray.forEach((dataItem) => {
                            track.content = track.content.map((ressource) => {
                              if (ressource.id === dataItem.item_id) {
                                delete ressource['hydrate']
                                // Mettre à jour la ressource avec les données reçues
                                return { ...ressource, ...dataItem };
                              }
                              return ressource;
                            });
                          });
                        })
                      ).subscribe();

                    }

                  })
                  return message
                } , tap(response=>console.log(response))
              ),catchError((error: any) => {
                return [] as MessageModel[];
              })
            )
          )
        ),
        scan((conversation , message ) => {
          const last_message = conversation[conversation.length - 1] ;
          if (
            message.type == 'in' &&
            last_message.type == 'in'
          ) {
            conversation[conversation.length - 1].text = message?.text;
            conversation[conversation.length - 1].typping =false;
            return conversation;
          }
          // conversation.push(message);
          // return conversation;
         return [...conversation, message];
        }, messages),
        // Met à jour les messages toutes les minutes
        switchMap((messages) =>
          interval(60000).pipe(
            startWith(0), //Pour ne pas attendre une minute pour afficher la première fois
            // map(() =>
            //   messages.map((message) => ({
            //     ...message,
            //     time: moment(message.createdAt).lang('fr').fromNow(),
            //   }))
            // )
            tap(()=>{
              messages.forEach((message)=>{
                message.time =  moment(message.createdAt).lang('fr').fromNow()
              })
            }),
            map(()=>messages)
          )
        ),
        startWith(messages)
      )
    ),
    tap(() => {
      setTimeout(() => {
        this.throttledScroll();
      }, 0);
    }),
    catchError((error: any) => {
      console.log(error);
      return of([]);
    })
  );

  histories$=this.chatService.getHistoy().pipe(
  map((data:any)=>(data?.data))
  );
  isSending$ = combineLatest([
    this.conversations$,
    this.monFormulaire.valueChanges,  // Assuming this is your FormGroup
    ]).pipe(
      map(([conversations, formValue]) => {
        const isTyping = conversations.some((msg) => msg.typping === true);
        const isMessageEmpty =  this.monFormulaire.controls.message.value==='';
        console.log("isTyping ",isTyping);
        console.log("isMessageEmpty ",isMessageEmpty);
        return isTyping || isMessageEmpty;
      })
    );

  onSubmit(): void {
    if (!this.monFormulaire.value.message) return;
    const data: MessageModel = {
      avatar: 'avatars/300-1.jpg', //TODO: get user avatar
      text: [{type : 'text', content: this.monFormulaire.value.message}],
      createdAt: new Date(),
      time: 'maintenant',
      type: 'out',
    };
    this.sendMessageEvent.emit({ data });
  }

  parseMd(text: string): string {
    if (1 == (text.match(/```/gi) || []).length % 2) {
      text += '\n```\n';
    }
    const parsed = this.mdpjs
      .render(text.replace('link://', 'help/'))
      .replace(/!\[([^\]]*)\]\(([^)]*)\)/gi, '<img alt="$1" src="$2">')
      .replace(/\[([^\]]*)\]\(([^)]*)\)/gi, '<a href="$2">$1</a>')
      .replace(/<a([^>]+)>/gi, '<a$1 target="_blank">')
      .replace(/<pre>/g, '')
      .replace(/<\/pre>/g, '');

    return parsed;
  }

  isSendDisabled() {
    return this.isSending$ || this.monFormulaire.controls.message.value === '';
  }
  loadSelectedConv(conv_id:any){
    this.chatService.conv_id.next(conv_id);
    this.chatService.send_convId.next(conv_id);
    this.chatService.currentAction.next('conversation')
  }
  parseTexte(texte, type_tags=['resources-viewer','faq-viewer', 'survey-viewer' , 'user-response', 'sessions-viewer','event-viewer']) {
    const type_tags_regex = type_tags.join('|');
    const regex = new RegExp(`([\\s\\S]*?)(\`\`\`(${type_tags_regex})\\n([\\s\\S]*?)\`\`\`)`, 'g');
    const parts = [];
    let lastIndex = 0;

    //return [regex.exec(texte),regex.exec(texte),regex.exec(texte)]

    let match = regex.exec(texte);
    while (match) {
      if (match[1].trim()) {
        parts.push({
          type: 'text',
          content: this.parseMd(match[1].trim())
        });
      }
      parts.push({
        type: match[3],
        content: JSON.parse(match[4].trim())
      });
      lastIndex = regex.lastIndex;

      match = regex.exec(texte);
    }

    // Capture any remaining text after the last block
    const remainingText = texte.slice(lastIndex).trim();
    if (remainingText) {
      parts.push({
        type: 'text',
        content: this.parseMd(remainingText)
      });
    }
    return parts
  }
  StringifyParse(text :messageContent[]){
    return text.map((dt)=>dt.type==='text' ? dt.content : "```"+dt.type+"\n"+JSON.stringify(dt.content)+"\n```").join("\n")

  }

  sendresponse(event: any) {
    console.log('response' , event)
    const conv = JSON.stringify(event)
    const data : MessageModel = {
      avatar: 'avatars/logo-sm.svg', //TODO: get user avatar
      // text: [{type:'text' , content :this.parseMd( 'repondu V ') , response : event}],
      // text :[{type:"text" , content:  "\n\n####Reponse\n```"+`user-response\n${conv}`+"```"}],
       text : this.parseTexte(  "```"+`user-response\n${conv}`+"```"),
      createdAt: new Date(), //TODO: get createdAt from server in the response
      time: 'maintenant',
      type: 'out',
    }
    this.sendMessageEvent.emit({data})
  }
  getTrackings(text: any[]){

  }
}

export const hello_message=
`
👋 Bienvenue sur M'assist, votre guide dans LCMS. Besoin d'aide pour naviguer ou des conseils spécifiques ? Je suis là pour rendre votre expérience d'apprentissage agréable et sans stress. 🚀🤖
`
